import React, { useState } from 'react';

const ChipInputWithSeparators = ({ chips, onAdd, onRemove, separator, classes }) => {
  const [inputValue, setInputValue] = useState('');

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && inputValue.trim() !== '') {
      onAdd(inputValue);
      setInputValue(''); // Clear the input field
      event.preventDefault();
    }
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  return (
    <div className={`custom-chip-container ${classes}`}>
      {chips?.length > 0 && chips?.map((chip, index) => (
        <React.Fragment key={index}>
          <div className="chip">
            <span>{chip}</span>
            <button onClick={() => onRemove(index)}>x</button>
          </div>
          {index < chips.length - 1 && (
            <span className="chip-separator">
              {separator}
            </span>
          )}
        </React.Fragment>
      ))}
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default ChipInputWithSeparators;